import UserSidebar from '../../COMPONENTS/UserProfile/UserSidebar'
import AccountSettings from '../../COMPONENTS/UserProfile/AccountSettings'
import './UserProfile.css'
import YourOrders from '../../COMPONENTS/UserProfile/YourOrders'
import UserAddress from '../../COMPONENTS/UserProfile/UserAddress'
import LegalNotice from '../../COMPONENTS/UserProfile/LegalNotice'
import Footer from '../../../features/footer/Footer';
import Navbar from '../../../features/navbar/Navbar'
import { useNavigate , useParams } from 'react-router-dom';
import React, { useState, useEffect } from "react";
import axios from "axios";
const UserProfile = () => {
  const [products, setProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const { pk } = useParams();
  const navigate = useNavigate(); // Hook to programmatically navigate
    const {activepage} = useParams()
    useEffect(() => {
      if (searchTerm.trim() !== '') {
        const fetchSearchResults = async () => {
          try {
            const response = await axios.get(
              `http://13.127.147.104/user_search_get/${pk}/`,
              {
                params: {
                  search: searchTerm
                }
              }
            );
            setProducts(response.data);
    
            // Redirect to the search results page
            navigate(`/user/allproducts/${pk}/`);
          } catch (error) {
            console.error('Error fetching search results:', error);
          }
        };
    
        fetchSearchResults();
      }
    }, [searchTerm, pk, navigate, setProducts]);
    
    const handleSearch = (e) => {
      setSearchTerm(e.target.value);
    };
      
    return (
      <div>
      <Navbar onSearch={setSearchTerm} />
    <div className='userprofile'>
         <div className='userprofilein'>
            <div className='left'>
              <UserSidebar activepage={activepage}/>
            </div>
              {activepage === 'accountsettings' && <AccountSettings/>}
              {activepage === '/user/yourorders' && <YourOrders/>}
              {activepage === '/user/address' && <UserAddress/>}
              {activepage === 'legalnotice' && <LegalNotice/>}
         </div>
         <Footer></Footer>
        </div>
    </div>
  )
}

export default UserProfile